<template>
  <v-app id="app" class="mk-app">
    <v-content class="mk-content">
      <div class="mk-content-background">
        <Home />
      </div>
    </v-content>
  </v-app>
</template>
<style>
html,
body {
  height: 100%;
  width: 100%;
  overflow-scrolling: unset;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
}

.mk-app {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
}

.mk-content {
  flex-grow: 1;
  width: 100%;
}
.mk-content-background {
  padding-top: 16px;
  padding-bottom: 16px;
  display: flex;
  min-height: 100%;
  background-color: #707070;
  background-image: url("itdesign-background.png");
  background-position-x: center;
  background-repeat: repeat;
  background-attachment: fixed;
  background-size: unset;
  background-position-y: 20px;
  overflow: auto;
}

@media only screen and (max-width: 800px) {
}
</style>
<script>
import Home from "@/home/Home.vue";

export default {
  name: "app",
  components: { Home }
};
</script>
